import React from 'react';
import SiteNav from '../components/SiteNav';
import SiteFooter from '../components/SiteFooter';

const CONTACT_EMAIL = 'rain@elevenup.xyz';

const ContactPage: React.FC = () => {
  return (
    <div className="landing-page">
      <SiteNav currentPage="contact" />

      {/* Hero */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Get in Touch</h1>
          <p className="page-hero-subtitle">We're a small team and we read every message.</p>
        </div>
      </section>

      {/* Content */}
      <section className="contact-content-section">
        <div className="container">
          {/* Email Card */}
          <div className="contact-card">
            <div className="contact-card-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#4FCCC6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
            </div>
            <h2>Email Us</h2>
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            <p className="contact-note">We usually reply within 24 hours, Monday to Friday.</p>
          </div>

          {/* What can we help with */}
          <div className="help-list">
            <h2>What can we help with?</h2>
            <div className="help-list-item">
              <span className="help-bullet"></span>
              Questions about ElevenUp or how it works
            </div>
            <div className="help-list-item">
              <span className="help-bullet"></span>
              Partnership or school enquiries
            </div>
            <div className="help-list-item">
              <span className="help-bullet"></span>
              Bug reports or feature suggestions
            </div>
            <div className="help-list-item">
              <span className="help-bullet"></span>
              Press or media requests
            </div>
            <div className="help-list-item">
              <span className="help-bullet"></span>
              Anything else &mdash; we'd love to hear from you
            </div>
          </div>

          {/* FAQ Section */}
          <div className="contact-faq">
            <h2>Frequently Asked Questions</h2>

            <div className="contact-faq-item">
              <h3>How quickly will I get a reply?</h3>
              <p>We aim to respond to every email within 24 hours on weekdays. If you contact us over the weekend, you'll hear back first thing Monday morning. We're a small team and we genuinely read every message.</p>
            </div>

            <div className="contact-faq-item">
              <h3>I'm a teacher or school &mdash; can we use ElevenUp?</h3>
              <p>Absolutely! We'd love to hear from schools interested in using ElevenUp for 11+ preparation. Whether you're looking for classroom resources, homework tools, or a way to support pupils preparing for grammar school entrance exams, drop us an email and we'll set up a conversation.</p>
            </div>

            <div className="contact-faq-item">
              <h3>I've found a bug or have a feature idea</h3>
              <p>We really appreciate bug reports and feature suggestions from parents and students. They help us make ElevenUp better for everyone. Just email us with as much detail as you can &mdash; what you expected to happen, what actually happened, and which device you were using. Screenshots are always helpful too.</p>
            </div>

            <div className="contact-faq-item">
              <h3>Is my child's data safe?</h3>
              <p>Your child's privacy is our top priority. We comply with UK GDPR, require parental consent before any child can use the app, and never share data with third parties. We don't use advertising or tracking. You can read our full <a href="/privacy">privacy policy</a> for complete details.</p>
            </div>

            <div className="contact-faq-item">
              <h3>Can I get a refund?</h3>
              <p>If you're not happy with your subscription, just email us and we'll sort it out. We want every family to feel confident they're getting value from ElevenUp. See our <a href="/terms">terms of service</a> for full details on our refund policy.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="contact-cta-section">
        <div className="container">
          <h2 className="section-title light">Ready to give them a head start?</h2>
          <p className="section-subtitle light">
            Join early access &mdash; free to start, no credit card needed.
          </p>
          <a href="/#waitlist" className="btn-primary-light">
            Get Early Access
          </a>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default ContactPage;
